export default "__VITE_ASSET__C6cj06HN__"